/**
 * @generated SignedSource<<fd233a74cd09b79c2a91250f6f1fd038>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type BuildState = "deleted" | "finished" | "queued" | "running" | "unknown";
import { FragmentRefs } from "relay-runtime";
export type BuildTypeInfoPanelFragment$data = {
  readonly build: ReadonlyArray<{
    readonly rawId: number | null | undefined;
    readonly startDate: string | null | undefined;
    readonly state: BuildState | null | undefined;
  }> | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"BuildsTimelineFragment">;
  readonly " $fragmentType": "BuildTypeInfoPanelFragment";
};
export type BuildTypeInfoPanelFragment$key = {
  readonly " $data"?: BuildTypeInfoPanelFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"BuildTypeInfoPanelFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuildTypeInfoPanelFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Build",
      "kind": "LinkedField",
      "name": "build",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "rawId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "state",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BuildsTimelineFragment"
    }
  ],
  "type": "Builds",
  "abstractKey": null
};

(node as any).hash = "e15842a303d599e11e51430c7b2d0300";

export default node;
